(function () {
  const SUPABASE_URL = 'https://zhadhjxsnmbnqdpiuiyw.supabase.co';
  const SUPABASE_KEY = 'sb_publishable_99An6wmeGvA4fxS906_I_w_fe0t3DfM';

  function initRatings() {
    const ratingEls = Array.from(document.querySelectorAll('[data-cud-rating]'));
    if (!ratingEls.length || !window.supabase) return;

    const handles = [...new Set(
      ratingEls
        .map(el => el.dataset.productHandle || '')
        .filter(Boolean)
    )];

    if (!handles.length) return;

    const supabase = window.supabase.createClient(SUPABASE_URL, SUPABASE_KEY);

    supabase
      .from('reviews')
      .select('product_handle, rating')
      .eq('status', 'approved')
      .in('product_handle', handles)
      .then(function ({ data, error }) {
        if (error || !data) return;

        const grouped = {};

        data.forEach(function (review) {
          if (!grouped[review.product_handle]) grouped[review.product_handle] = [];
          grouped[review.product_handle].push(Number(review.rating || 0));
        });

        ratingEls.forEach(function (el) {
          const handle = el.dataset.productHandle || '';
          const ratings = grouped[handle];

          if (!ratings || !ratings.length) return;

          const count = ratings.length;
          const avg = ratings.reduce((a, b) => a + b, 0) / count;

          el.innerHTML = `
            <span class="cud-rating-stars">★★★★★</span>
            <span class="cud-rating-score">${avg.toFixed(1)}</span>
            <span class="cud-rating-count">(${count})</span>
          `;

          el.hidden = false;
        });
      });
  }

  document.addEventListener('DOMContentLoaded', initRatings);
})();